/* global trapFocus */
window.addEventListener('load', () => {
  const sortContainer = document.querySelector('.ss-sort-by')
  const sortOptPanel = document.querySelector('.ss-sort-by .ss__dropdown__content')
  const dropdownButton = document.querySelector('.ss-sort-by .ss__select__dropdown__button')
  const dropdown = document.querySelector('.ss-sort-by .ss__dropdown')
  if (!sortOptPanel || !sortContainer || !dropdownButton || !dropdown) return

  trapFocus(sortOptPanel)

  const openSortBtn = document.querySelector('.ss-sort-by .ss__select__label')
  const dropdownTriggerWrapper = dropdownButton.closest('[aria-expanded][role="button"]')
  const focusTarget = openSortBtn || dropdownTriggerWrapper || dropdownButton

  function closeSortDropdown() {
    if (!dropdown.classList.contains('ss__dropdown--open')) return
    dropdown.classList.remove('ss__dropdown--open')
    dropdownTriggerWrapper?.setAttribute('aria-expanded', 'false')
    focusTarget?.focus()
  }

  function clickedOnInnerButton(e) {
    return dropdownButton === e.target || dropdownButton.contains(e.target)
  }

  let wasOpenAtMouseDown = false
  let closedByUsOnMouseDown = false

  document.addEventListener(
    'mousedown',
    (e) => {
      if (sortContainer.contains(e.target)) {
        wasOpenAtMouseDown = dropdown.classList.contains('ss__dropdown--open')
      }
      if (e.button !== 0 || !e.isTrusted || !sortContainer.contains(e.target) || !wasOpenAtMouseDown || !clickedOnInnerButton(e)) return
      e.preventDefault()
      e.stopPropagation()
      closedByUsOnMouseDown = true
      closeSortDropdown()
    },
    true
  )

  document.addEventListener(
    'click',
    (e) => {
      if (!closedByUsOnMouseDown) return
      if (sortContainer.contains(e.target)) {
        e.preventDefault()
        e.stopPropagation()
      }
      closedByUsOnMouseDown = false
    },
    true
  )

  sortContainer.addEventListener(
    'click',
    (e) => {
      if (!e.isTrusted || !wasOpenAtMouseDown || !dropdown.classList.contains('ss__dropdown--open') || !clickedOnInnerButton(e)) return
      setTimeout(closeSortDropdown, 0)
    },
    false
  )

  sortOptPanel.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeSortDropdown()
      document.dispatchEvent(new Event('focusOnSortTrigger'))
    }
    if (e.key === 'Enter' && focusTarget) {
      document.dispatchEvent(new Event('focusOnSortTrigger'))
    }
  })

  if (focusTarget) {
    focusTarget.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && dropdown.classList.contains('ss__dropdown--open')) {
        closeSortDropdown()
        document.dispatchEvent(new Event('focusOnSortTrigger'))
      }
    })
  }

  document.addEventListener('focusOnSortTrigger', () => focusTarget?.focus())
})
